export default class CardsHandler {
	init() {
		this.equalizeCardHeights();
		window.addEventListener('resize', () => this.equalizeCardHeights());
	}

	equalizeCardHeights() {
		const eventsContainer = document.querySelector('[data-posts-container][data-post-type="cpt-events"]');
		const publicationsContainer = document.querySelector('[data-posts-container][data-post-type="cpt-publications"]');

		let maxHeight = 0;
		const allCards = [];

		[eventsContainer, publicationsContainer].forEach(container => {
			if (container) {
				const children = Array.from(container.children);
				children.forEach(child => {
					// Reset height first to get natural height
					child.style.height = '';
					allCards.push(child);
					const height = child.offsetHeight;
					if (height > maxHeight) {
						maxHeight = height;
					}
				});
			}
		});
		
		allCards.forEach(card => {
			card.style.height = `${maxHeight}px`;
		});
	}
}
